import Vue from "vue";
import Vuex from "vuex";
import Service from "../../../../service/api.js";
import store from "@/store/store";

const ServerModule = {
    namespaced: true,
    state: {
        item:[],
        trainingDemand: {
            summary: {
                totalCourses: 0,
                totalSelections: 0,
                totalPeople: 0,
            },
            courses: [],
            items: []
        },
    },

    mutations: {
        item(state, obj) {
            state.item = obj;
        },
        trainingDemand(state, obj) {
            state.trainingDemand = obj;
        },
    },

    actions: {
        status({commit}, data) {
            return Service.idpReport('status', data, {})
                .then((response) => {
                    store.commit("idpReport/item", response.data.data)
                    return response
                }).catch((err) => {
                    throw err
            });
        },
        trainingDemand({commit}, data) {
            return Service.idpReport('training-demand', data, {})
                .then((response) => {
                    store.commit("idpReport/trainingDemand", response.data.data)
                    return response
                }).catch((err) => {
                    throw err
            });
        },
    },

    getters: {
        item(state, obj) {
            return state.item;
        },
        trainingDemand(state, obj) {
            return state.trainingDemand;
        },

    },
};

export default ServerModule;
